import React from "react";
import Field from "./Field";
import DecimalControl from "./DecimalControl";
import { FieldProps } from "./Types";

const DecimalField: React.FC<FieldProps> = ({ labelProps, controlProps, visible, disabled }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <DecimalControl {...controlProps} disabled={disabled} />
        </Field>
    );
}
export default DecimalField;